import { Injectable } from '@angular/core';

import { Firestore, collection, deleteDoc, doc, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { Customer, User } from '@seasidebeta/types';
import { Observable, Subscription } from 'rxjs';

import { CustomerDatabase } from '@seasidebeta/components';

@Injectable({
    providedIn: 'root'
})
export class usersDatabase {
    currentUserSubscription: Subscription
    currentUserObservable: any;
    users: Observable<any>;


    constructor(
        private afs: Firestore,
        private customer: CustomerDatabase,
    ) {

    }

    stripUserData(user: User.CustomerUser, additionalFields?: Array<'birthDate'>): User.CustomerUser {
        let strippedUser: User.CustomerUser = {
            id: user.id ?? '',
            firstname: user.firstname ?? '',
            lastname: user.lastname ?? '',
            nickname: user.nickname ?? '',
            country: user.country ?? {},
            phone: user.phone ?? '',
            email: user.email ?? '',
        }
        if (additionalFields) {
            additionalFields.forEach(field => {
                if (user[field]) strippedUser[field] = user[field]
            })
        }
        return strippedUser
    }

    getNewRef() {
        return doc(collection(this.afs, 'users')).id
    }

    // createUserProfile(user: User.CustomerUser): Promise<{id: string}> {
    //     const id = this.getNewRef()
    //     const queue = {
    //         id,
    //         email: user.email,
    //         // password: password,
    //         // passwordd: password,
    //         userId: user.id,
    //         // message: message,
    //         timestamp: new Date()
    //     }
    //     return new Promise((res, rej) => {
    //         setDoc(this.customer.getDocumentFirestoreReference(['customer-queues', 'users', 'customer-queues-users', id]), queue).then(() => {
    //             res(queue)
    //         })
    //     })
    // }

    // updateUserProfile(user: User.CustomerUser): Promise<{id: string}> {
    //     var message = {
    //         to: user.firstname + ' ' + user.lastname + '<' + user.email + '>',
    //         from: "Skjærgårds Crew <noreply@mail.crew.sgospel.no>",
    //         replyTo: 'post@sginfo.no',
    //         templateId: "d-d29eba75f28f4bfea42afb3abcd4038d",
    //         dynamic_template_data: {
    //             "name": user.firstname,
    //             "username": user.email,
    //             "magic-link": "?username=" + user.email
    //         }
    //     }
    //     const id = this.getNewRef()
    //     const queue = {
    //         id,
    //         email: user.email,
    //         user_id: user.id,
    //         uid: user.uid,
    //         message: message
    //     }
    //     return new Promise((res, rej) => {
    //         setDoc(this.customer.getDocumentFirestoreReference(['customer-queues', 'users', 'customer-queues-users', id]), queue).then(() => {
    //             res(queue)
    //         })
    //     })
        
    // }

    // deleteUserProfile(user: User.CustomerUser) {
    //     const id = this.getNewRef()
    //     const queue = {
    //         id,
    //         email: user.email,
    //         user_id: user.id,
    //         uid: user.uid,
    //         deleteUser: true
    //     }
    //     return new Promise((res, rej) => {
    //         setDoc(this.customer.getDocumentFirestoreReference(['customer-queues', 'users', 'customer-queues-users', id]), queue).then(() => {
    //             res(queue)
    //         })
    //     })
    // }

    getUsersQueue(queueId: string) {
        return this.customer.getDocumentFirestoreReference(['customer-queues', 'users', 'customer-queues-users', queueId])
    }

    getActiveUserData(uid) {
        return query(
            this.customer.getCollectionFirestoreReference<User.CustomerUser>(['customer-users']),
            where('uid', '==', uid)
        )
    }

    getActiveUserDataFromUIDS(uid: string) {
        return query(
            this.customer.getCollectionFirestoreReference<User.CustomerUser>(['customer-users']),
            where('uids', 'array-contains', uid)
        )
    }

    updateUser(user: User.CustomerUser) {
        return updateDoc(this.customer.getDocumentFirestoreReference<User.CustomerUser>(['customer-users', user.id]), user as any);
    }

    async newUser(user: User.CustomerUser): Promise<User.CustomerUser> {
        user.id = this.getNewRef()
        return new Promise((res, rej) => {
            setDoc(this.getCustomerUserfromID(user.id), user).then(() => {
                res(user)
            })
        })
    }

    getUserGroups(userId: string) {
        return this.customer.getCollectionFirestoreReference<User.userDataGroup>(['customer-users', userId, 'customer-user-groups'])
    }

    getCrewUsers() {
        return collection(this.afs, 'crew-users')
    }

    getUsers() {
        return this.customer.getCollectionFirestoreReference<User.CustomerUser>(['customer-users'])
    }

    getCustomerUsersFromIds(ids: string[]) {
        return query(
            this.customer.getCollectionFirestoreReference<User.CustomerUser>(['customer-users']),
            where('id', 'in', ids)
        )
    }

    getCustomerUserFromId(id: string) {
        return this.customer.getDocumentFirestoreReference<User.CustomerUser>(['customer-users', id])
    }

    getUserGroupsFromEventId(userId: string, eventIds: Array<string>) {
        return query(
            this.customer.getCollectionFirestoreReference<User.userDataGroup>(['customer-users', userId, 'customer-user-groups']),
            where('eventId', 'in', eventIds))
    }

    getCustomerUserfromID(userId: string) {
        return this.customer.getDocumentFirestoreReference<User.CustomerUser>(['customer-users', userId])
    }

    getUserfromID(userId: string) {
        return doc(this.afs, 'users', userId)
    }

    getUserMessages(userId: string) {
        return this.customer.getDocumentFirestoreReference(['customer-users', userId, 'messages'])
    }

    getUserMessage(userId: string, messageId: string) {
        return this.customer.getDocumentFirestoreReference(['customer-users', userId, 'messages', messageId])
    }

    getUserFromUID(uid: string) {
        return query(
            this.customer.getCollectionFirestoreReference(['customer-users']),
            where('uid', '==', uid))
    }

    getUsersFromIds(ids: Array<string>) {
        return query(
            this.customer.getCollectionFirestoreReference(['customer-users']),
            where('id', 'in', ids))
    }

    deleteUser(user: User.CustomerUser) {
        const user_id = null
        if (user_id === parseInt(user.id, 10)) {
            user.id = user_id.toString();
        }
        return deleteDoc(this.customer.getDocumentFirestoreReference(['customer-users', user.id]))
    }

    // getStrippedCurrentUser(): User.User {
    //     return {
    //         uid: this.currentUser.uid ?? '',
    //         firstname: this.currentUser.firstname ?? '',
    //         lastname: this.currentUser.lastname ?? ''
    //     }
    // }
}